export const getTerminalTextStyle = (theme) => ({
  fontFamily: theme.fontFamily,
  fontSize: "1rem",
  lineHeight: "1.2rem",
});

export const getInputStyle = (theme, isFocused, terminalTextStyle) => ({
  backgroundColor: isFocused
    ? theme.backgroundColorFocused
    : theme.backgroundColor,
  color: theme.color,
  caretColor: theme.color,
  border: "none",
  outline: "none",
  flex: 1,
  padding: 0,
  margin: 0,
  resize: "none",
  overflow: "hidden",
  ...terminalTextStyle,
});

export const getContainerStyle = (
  theme,
  isFocused,
  terminalTextStyle,
  height,
  display,
  opacity,
  transition
) => ({
  display: display ? "block" : "none",
  opacity: opacity,
  backgroundColor: isFocused
    ? theme.backgroundColorFocused
    : theme.backgroundColor,
  color: theme.successColor,
  padding: "1rem",
  borderRadius: theme.borderRadius || "8px",
  height: height,
  overflowY: "auto",
  transition: transition,
  ...terminalTextStyle,
});

export const getFormStyle = (theme) => ({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "flex-start",
  marginTop: "0px",
  background: "transparent",
  borderRadius: theme?.borderRadius || "6px",
  transition: "background 0.2s",
});

export const getPromptSpanStyle = (
  theme,
  terminalTextStyle,
  isCurrentPrompt = false
) => ({
  marginRight: "0.5rem",
  whiteSpace: "pre-wrap",
  color: isCurrentPrompt ? theme.successColor : theme.promptColor,
  ...terminalTextStyle,
});

export const getSuggestionStyle = (terminalTextStyle) => ({
  whiteSpace: "pre-wrap",
  marginTop: "0.2rem",
  ...terminalTextStyle,
});
